import { render, staticRenderFns } from "./TenderList.vue?vue&type=template&id=e5a45fce&"
import script from "./TenderList.vue?vue&type=script&lang=js&"
export * from "./TenderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports